import { useTranslation } from 'react-i18next';

import { Button } from '../../components/Button';
import { ErrorNotice } from '../../components/ErrorNotice';
import { LoadingIndicator } from '../../components/Spinner';
import { useSession, useSwitchTenant } from './queries';

/**
 * Mandantenauswahl.
 *
 * Erscheint fuer Bearbeiter, die fuer mehrere Mandanten freigeschaltet sind.
 * Bis zur Auswahl traegt das Zugangstoken keinen Mandanten, und jeder
 * fachliche Endpunkt antwortet mit 403 -- die Auswahl ist also nicht
 * Bequemlichkeit, sondern der Weg, auf dem der Sitzungskontext seinen
 * Mandanten bekommt.
 */
export function TenantSelectPage() {
  const { t } = useTranslation();
  const session = useSession();
  const switchTenant = useSwitchTenant();

  if (session.isPending) return <LoadingIndicator />;
  if (session.isError) return <ErrorNotice error={session.error} />;

  return (
    <div className="centered-page">
      <div className="card centered-page__card">
        <h1>{t('auth.switchTenant')}</h1>
        <p style={{ color: 'var(--color-text-secondary)', marginBottom: 'var(--space-6)' }}>
          {t('auth.selectTenant')}
        </p>

        {switchTenant.isError ? <ErrorNotice error={switchTenant.error} /> : null}

        <div className="stack">
          {(session.data.available_tenants ?? []).map((tenant) => (
            <Button
              key={tenant.id}
              variant="secondary"
              block
              busy={switchTenant.isPending}
              onClick={() => {
                switchTenant.mutate(tenant.id);
              }}
            >
              {tenant.name}
            </Button>
          ))}
        </div>

        {/* Woher ein neuer Mandant kommt. Ohne diesen Satz sucht ein
            Administrator hier eine Schaltflaeche, die es nicht gibt und aus
            gutem Grund nicht geben soll -- die Begruendung steht im Kopf von
            ``modules/tenants/router.py``. */}
        <p className="field__hint" style={{ marginTop: 'var(--space-6)' }}>
          {t('auth.newTenantHint')}
        </p>
      </div>
    </div>
  );
}
